import { useEffect, useState, useLayoutEffect,useRef } from "react";
import { useHistory } from "react-router-dom";
import { useRtoaster } from "../../hooks/useRtoaster";
import { connect } from "react-redux";
import useMedia from "use-media";
import { Button } from "../atoms/button";
import ConditionDesignationArea from "../molecules/conditionDesignationArea";
import VacancyInfoContainer from "./vacancyInfoContainer";
import { detailConditionApi, golfFacility, searchResultApi ,versionGetApi,vacancyOverviewApi} from "../../const";
import img_save from '../../resources/icons/ico_memo.svg';
import { useStore } from "react-redux";
import common from "../../resources/js/common/common.js"
import { apiKeyCheck } from "../../const";
import VacancyInfoContainerCallender from "./vacancyInfoContainerCallender";
import { Label } from "../atoms/label";
import { Link } from "react-router-dom";
import { default as commonUtil } from "../../common/commonUtil";
import { GetPublicHoliday } from "../../hooks/getPublicHoliday";

const groups = [
    { id: "1", value: "1組", selected: true },
    { id: "2", value: "2組", selected: false },
    { id: "3", value: "3組", selected: false },
];

const GolfSearchContainer = (props) => {
    const { 
        playDate1,
        setPlayDate1,
        group,
        course,
        detailCondition,
        startTime,
        setDetailCondition,
        setCourse,
        setStartTime,
        setGroup,
        setSearchResult,
        setKaiinken,
        kaiinken,
        login,
        addTeeTimeList,
        onClickOpenSavedSearchCriteriaWindow,
        setReserveCheckInfo,
        onClickOpenSelectDateWindow,
        onClickOpenStartTimeWindow,
        onClickOpenSelectAreaWindow,
        setChangeReserveNo,
        changeReserveNo,
        onClickOpenFacilityCalendarWindow
     } = props;

    const [NotSearch,setNotSearch]= useState(false);
    const [NotStart,setNotStart]= useState(false);
    const [NotDate,setNotDate]= useState(false);
    const [NotFacility,setNotFacility]= useState(false);
    const [startTimes,setStartTimes]= useState([
        { id: "7", value: "7時台", category: "スタート時刻", class: "start_time", checked: false },
        { id: "8", value: "8時台", category: "スタート時刻", class: "start_time", checked: false },
        { id: "9", value: "9時台", category: "スタート時刻", class: "start_time", checked: false },
        { id: "10", value: "10時台", category: "スタート時刻", class: "start_time", checked: false },
        { id: "11", value: "11時台以降", category: "スタート時刻", class: "start_time", checked: false }
    ]);


    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    const [displaySwitch, setDisplaySwitch] = useState(true);

    const [vacancyInfo, setVacancyInfo] = useState([]);
    const [vacancyWeek, setVacancyWeek] = useState([]);
    const [MonthHead, setMonthHead] = useState("");
    const [MonthLast, setMonthLast] = useState("");

    // rtoasterタグ生成
    useRtoaster();

    const history = useHistory();
    const store = useStore();

    const firstDate = useRef(null);

    const { getHoliday } = GetPublicHoliday();

    const [searchVacancyParam, setSearchVacancyParam] = useState({
        startDate: "",
        courseId: "",
        teeTime: "", 
        partyCount: 1,
        membershipAuthID:"",
        userFacility: "",
        kaiinKind:"",
        courseId: [],
    });

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    useLayoutEffect(() => {
        // リフレッシュ対応
          let state = store.getState().login;
          let apiKey = null;
          if(Object.keys(state).length !== 0){   
              apiKey = state.apiKey;
          }
          if(apiKey === null){
              store.dispatch({ type: "CLEAR_STATE"});
              history.push("/reserve/login");
          }
          if(apiKey){
              common.doPost(apiKeyCheck, {apikey:apiKey}, afterApiKeyCheck);
          }
      })
      const afterApiKeyCheck = (res) => {
          if(!res.data){
              console.log("バックからの戻り値false");
              store.dispatch({ type: "CLEAR_STATE"});
              history.push("/reserve/login");
          }
      }
      
    // API呼出等事前処理
    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);

        // プレー日初期化処理
        let newPlayDate = new Date();
        newPlayDate.setFullYear(newPlayDate.getFullYear(), newPlayDate.getMonth(), newPlayDate.getDate() + 3)
        setPlayDate1(newPlayDate);
        firstDate.current = newPlayDate;

        // 詳細条件取得処理
        common.doPost(detailConditionApi, {}, afterGetDetailCondition);

        // 開始時間設定処理
        if(startTime.length < 1){
            setStartTime(startTimes);
        }
        else{
            setStartTime(startTime);
        }

        // 組数設定処理
        if(group.length < 1){
            setGroup(groups);
        }
        else{
            setGroup(group)
        }
        // 会員権情報設定処理
        // if(kaiinken == undefined || kaiinken.length === 0){
        //     getKaiinken();
        // }
        // else{
        //     setKaiinken(kaiinken);
        // }

        if(course.length < 1){
            // 施設取得処理
            // let reqData = facilityReqData();
            // console.log("施設取得のリクエストデータ");
            // console.log(reqData);
            // common.doPost(golfFacility, {kaiinKind:reqData.kaiinKind,sisetuCd:reqData.sisetuCd}, afterGetFacility);
        }
        else {
            setCourse(course);
        }
        window.scroll({top:0, behavior: 'smooth'})
    }, []);



    //施設取得APIのリクエスト値を生成
    // const facilityReqData = () => {
    //     let reqData
    //     kaiinken.forEach((data) => {
    //         if (data.selected === true) {
    //             reqData = {
    //                 kaiinKind : data.kaiinkenSyubetCd,
    //                 sisetuCd : data.sisetuCd,
    //             }
    //         }
    //     });
    //     return reqData;
    // }


    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if(flg){
            history.push("/reserve/login");
            return;
        }
    }

    // 詳細条件取得後処理
    const afterGetDetailCondition = (res) => {
        const data = res.data.map((item) => {
            return {
                id: item.detailsId,
                value: item.detailsConditions,
                category: item.detailsCategoryCd,
                class: "play_style",
                checked: false
            };
        });

        setDetailCondition(data);
    }

    // 施設取得後処理
    const afterGetFacility = (res) => {
        const data = res.data.map((item) => {
            return {
                id: item.courseid,
                facilityCd: item.facility_cd,
                value: item.facility_name,
                category: item.hotel_category_name,
                class: "area_course",
                checked: true,
                zip: item.zip,
                address: item.address,
                access_car: item.access_car,
                facility_overview_title: item.facility_overview_title,
                facility_overview_detail: item.facility_overview_detail,
                url: item.url,
                image_path: item.image_path,
                memberShipAuth: item.memberShipAuth
            };
        });

        setCourse(data);
    }

    // 検索ボタン押下時
    const onClickSearch = () => {

        setNotStart(false);
        setNotSearch(false);
        setNotFacility(false);
        setReserveCheckInfo([]);
        setChangeReserveNo("");
        addTeeTimeList([]);

        // 選択した詳細条件をstoreに保存
        const arry = [];
        const elements = document.getElementsByClassName("play_style");
        for (let i in elements) {
            if (elements[i].checked == true) {
                arry.push(elements[i].value);
            }
        }

        for (let i in detailCondition) {
            let index = arry.indexOf(detailCondition[i].id);
            if (index >= 0) {
                detailCondition[i].checked = true;
            } else {
                detailCondition[i].checked = false;
            }
        }

        let groupNumber = 1;
        group.forEach((data) => {
            if (data.selected === true) groupNumber = parseInt(data.id);
        });

        const courseArray = [];
        course.forEach((data) => {
            if (data.checked === true) courseArray.push(data.id);
        });

        //選択された会員権から施設コードを詰め込む
        let courseArrayKaiinken;
        let useMemberShipAuth;
        let kaiinKind;
        kaiinken.forEach((data) => {
            if (data.selected === true) {
                courseArrayKaiinken = data.sisetuCd;
                kaiinKind = data.kaiinkenSyubetCd;
                course.forEach((courseData) => {
                    if(courseData.id === data.facilityCd){
                        useMemberShipAuth = courseData.memberShipAuth
                    }
                })
            }
        });
        if(courseArrayKaiinken === null || courseArrayKaiinken === undefined
            || useMemberShipAuth === null || useMemberShipAuth === undefined
            || kaiinKind === null || kaiinKind === undefined){
                setNotSearch(true);
                return;
        }

        const detailArray = [];
        detailCondition.forEach((data) => {
            if (data.checked === true) detailArray.push(data.id);
        });

        const startTimeArray = [];
        startTime.forEach((data) => {
            if (data.checked === true) startTimeArray.push(data.id);
        });

        if (!playDate1) {
            setNotDate(true);
        }
        // if (!courseArray.length) {
        //     setNotFacility(true);
        // }

        if (!playDate1) {
            common.scrollWindow("condition");
            return;
        }

        const playDate = new Date(playDate1);
        let y = playDate.getFullYear();
        let m = playDate.getMonth() + 1;
        let d = playDate.getDate();

        if (m < 10) m = `0${m}`
        if (d < 10) d = `0${d}`

        // リクエスト情報設定
        const req = {
            playDate: `${y}-${m}-${d}`,
            days: '1',
            partyCount: groupNumber,
            courseId: courseArray,
            playStyle: detailArray,
            teeTime: startTimeArray,
            membershipAuthID:useMemberShipAuth,
            userFacility: courseArrayKaiinken,
            kaiinKind:kaiinKind,
        };
        console.log("検索処理リクエスト値");
        console.log(req);
        

        // 詳細条件取得処理
        common.doPost(searchResultApi, req, afterSearch);
    }

    // 検索後処理
    const afterSearch = (res) => {
        const data = res.data;
        if(data.golfCourses === undefined){
            // 取得エラー処理
            setNotSearch(true);
            common.scrollWindow("condition");
            return;
        }

        const result = course.map((item) => {
            for (let i = 0; i < data.golfCourses.length; i++) {
                if (data.golfCourses[i].name === item.value) {
                    const resData = data.golfCourses[i];
                    const fac = {
                        courseid: item.courseid,
                        zip: item.zip,
                        address: item.address,
                        access_car: item.access_car,
                        facility_overview_title: item.facility_overview_title,
                        facility_overview_detail: item.facility_overview_detail,
                        url: item.url,
                        image_path:item.image_path,
                    }
                    Object.assign(resData, fac);
                    return resData;
                }
            }
            return null;
        });
        const re = result.filter(item => item != null);

        const resultData = {
            golfCourses: re
        }

        //表示施設のソート処理
        resultData.golfCourses.sort(function(first,second){
            if (first.facilitySort > second.facilitySort){
                return 1;
            }else if (first.facilitySort < second.facilitySort){
                return -1;
            }else{
                return 0;
            }
        })

        setSearchResult(resultData);

        // 画面遷移
        history.push("/reserve/golf/searchResult");
    }

    // コース数表示処理
    const getCourseCount = () => {
        let count = 0;
        for (let i in course) {
            if (course[i].checked === true) {
                count += 1;
            }
        }
        return count;
    }

    //会員権取得処理
    const getKaiinken = (res) => {
        let state = login;
        let memberInfo = null;
        let kaiinkenList = [];
        if(Object.keys(state).length !== 0){
            memberInfo = state.memberInfo;
        }
        if(memberInfo !== null && memberInfo.length !== 0){
            for(let i = 0; i < memberInfo.length; i++){
                if(memberInfo[i].memberList !== null){
                    if(!memberInfo[i].memberList.error && memberInfo[i].memberList.data.kaiinInfoList.length !== 0){
                        for(let j = 0; j < memberInfo[i].memberList.data.kaiinInfoList.length; j++){
                            if(memberInfo[i].memberList.data.kaiinInfoList[j].ownerNo){
                                if(memberInfo[i].memberList.data.kaiinInfoList[j].sisetuCd){
                                    const fac = {
                                        sisetuCd: memberInfo[i].memberList.data.kaiinInfoList[j].sisetuCd,
                                        ownerNo: memberInfo[i].memberList.data.kaiinInfoList[j].ownerNo,
                                        contractNo:memberInfo[i].memberList.data.kaiinInfoList[j].keiyakuNo,
                                        kaiinkenSyubetCd:memberInfo[i].memberList.data.kaiinInfoList[j].golfKaiinkenSyubetCd,
                                    }
                                    
                                    // 施設CDを変換する
                                    if (fac.sisetuCd === '223' || fac.sisetuCd === '224' ) {
                                        fac.sisetuCd = '804';
                                    }

                                    kaiinkenList.push(fac);
                                }
                            }
                        }
                    }
                }
            }
        }
        console.log(kaiinkenList);
        common.doPostRef(golfFacility, {kaiinKind:kaiinkenList[0].kaiinkenSyubetCd,sisetuCd:kaiinkenList[0].sisetuCd},kaiinkenList, afterGetFacility);
        let selectObjList = [];
        if(kaiinkenList.length !== 0){
            for(let i = 0; i < kaiinkenList.length; i++){
                const data = res.data.map((item) => {
                    if(kaiinkenList[i].sisetuCd === item.facility_cd){
                        let selectObj = {};
                        if(selectObjList.length===0){
                            selectObj["selected"] = true;
                        }
                        else{
                            selectObj["selected"] = false;
                        }
                        console.log("会員権log");
                        console.log(kaiinkenList[i].ownerNo);
                        console.log(item.facility_name);
                        console.log(item.courseid);
                        console.log(kaiinkenList[i].contractNo);
                        console.log(kaiinkenList[i].kaiinkenSyubetCd);
                        console.log(kaiinkenList[i].sisetuCd);
                        selectObj["id"] = kaiinkenList[i].ownerNo;
                        selectObj["facility"] = item.facility_name;
                        selectObj["facilityCd"] = item.courseid;
                        selectObj["contractNo"] = kaiinkenList[i].contractNo;
                        selectObj['kaiinkenSyubetCd'] = kaiinkenList[i].kaiinkenSyubetCd;
                        selectObj["value"] = kaiinkenList[i].ownerNo+"："+item.facility_name;
                        selectObj["sisetuCd"] = kaiinkenList[i].sisetuCd;
                        console.log(selectObj);
                        selectObjList.push(selectObj);
                        
                    }
                })
                
            }
        }
        // setKaiinken(selectObjList);

        // 施設取得処理
        console.log("施設取得のリクエストデータ");
        console.log(selectObjList);
        common.doPost(golfFacility, {kaiinKind:selectObjList[0].kaiinkenSyubetCd,sisetuCd:selectObjList[0].sisetuCd}, afterGetFacility);
    }

    // カレンダー検索用検索情報取得
    const runGetVacancyList = (req) => {
        setSearchVacancyParam(req);
        common.doPost(vacancyOverviewApi, req, afterGetVacancy);
    }

    // 空き情報取得後処理
    const afterGetVacancy = (res) => {
        const date = new Date(res.data.startDate);
        console.log(date);
        console.log(res.data);
        let twoWeeks = getWeekList(date); 
        getYearMonth(twoWeeks);
        // 2週間分の空き情報
        getVacancyList(res.data.facilities, twoWeeks);        
    }

    // 2週間分の空き情報
    const getVacancyList = (data, weekArray) => {
        let temp = [];
        if(data !== undefined){
            course.forEach((c)=>{
                let filtered = data.filter((d)=>{return c.id === d.facilityId});
                if(filtered.length){
                    filtered  = filtered[0];
                    const arry = filtered.vacancy.map((data, index) => {
                        return {
                            facilityName: filtered.facilityName,
                            courseId: filtered.facilityId,
                            vacancy: data,
                            okng: data === 3 ? false : true,
                            date: weekArray[index].date,
                            sortNum:filtered.facilitySort
                        }
                    });
                    temp.push(arry);
                }
                else {
                    const arry = []
                    for (let i=0;i < 14; i++){
                        arry.push({"facilityName": c.value,"courseId": c.id," vacancy": 3,"okng": false});
                    }
                    temp.push(arry);
                }
            });
        }
        //選択された施設で絞る
        let tempList = [];
        temp.map((data) => {
            course.map((courseData) => {
                if(courseData.checked && courseData.id === data[0].courseId){
                    tempList.push(data);
                }
            })
        })
        //並び替え
        //表示施設のソート処理
        tempList.sort(function(first,second){
            if (first[0].sortNum > second[0].sortNum){
                return 1;
            }else if (first[0].sortNum < second[0].sortNum){
                return -1;
            }else{
                return 0;
            }
        })
        console.log(tempList);
        setVacancyInfo(tempList);
    }

    // 2週間分の日付情報
    const getWeekList = (nextDate) => {
        console.log(nextDate);
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const array = [];
        for (let i = 0; i < 14; i++) {
            const date = new Date(nextDate.getFullYear(), nextDate.getMonth(), nextDate.getDate() + i);

            let color = "";
            switch(date.getDay()) {
                case 0:
                    color = "red";
                    break;
                case 6:
                    color = "blue";
                    break;
                default:
                    color = "black";
                    break;
            }

            // 祝日は赤色に変更
            let holiday = getHoliday(date, date, "month");
            if (holiday === "react-calendar__tile_holiday") {
                color = "red";
            }

            const week = {
                day: date.getDate().toString(),
                month: date.getMonth(),
                week: youbi[date.getDay()],
                color: color,
                date: date,
            }
            array.push(week);
        }
        setVacancyWeek(array);
        return array;
    }

    // カレンダーの年月の表示
    const getYearMonth = (twoWeeks) => {
        const playDate = new Date(playDate1);
        const yr = playDate.getFullYear();
        const mHead = twoWeeks[0].month
        const mLast = twoWeeks[13].month

        if ((!isMobilePhone && twoWeeks[0].month === twoWeeks[13].month) || (isMobilePhone && twoWeeks[0].month === twoWeeks[6].month)) {
            setMonthHead(<p><span style={isMobilePhone ? style.yearStyleMobile : style.yearStyle}>{yr}年</span><span style={isMobilePhone ? style.monthStyleMobile : style.monthStyle}>{mHead + 1}月</span></p>);
        } else {
            setMonthHead(<p><span style={isMobilePhone ? style.yearStyleMobile : style.yearStyle}>{yr}年</span><span style={isMobilePhone ? style.monthStyleMobile : style.monthStyle}>{mHead + 1}月 ~ {mLast + 1}月</span></p>);
        }
    }

    // カレンダー空室情報移動
    const onClickMoveWeeks = (type, mobile) => {
        let newDate = commonUtil.getDateFromString(searchVacancyParam.startDate, "-");
        if (type === "back") {
            if (mobile) {
                newDate.setDate(newDate.getDate() - 7);
            } else {
                newDate.setDate(newDate.getDate() - 14);
            }
        } else {
            if (mobile) {
                newDate.setDate(newDate.getDate() + 7);
            } else {
                newDate.setDate(newDate.getDate() + 14);
            }
        }
        let nextYearDate = new Date();
        nextYearDate.setFullYear(nextYearDate.getFullYear() + 1);
        nextYearDate.setHours(0);
        nextYearDate.setMinutes(0);
        nextYearDate.setSeconds(0);
        nextYearDate.setMilliseconds(0);

        firstDate.current.setHours(0);
        firstDate.current.setMinutes(0);
        firstDate.current.setSeconds(0);
        firstDate.current.setMilliseconds(0);
        
        console.log(newDate);
        console.log(firstDate.current);
        console.log(newDate >= firstDate.current);
        if (newDate <= nextYearDate) {
            let req = {
                startDate: newDate >= firstDate.current ? commonUtil.getStringFromDate(newDate, "yyyy-MM-dd") : commonUtil.getStringFromDate(firstDate.current, "yyyy-MM-dd"),
                courseId: searchVacancyParam.courseId,
                teeTime: searchVacancyParam.teeTime, 
                partyCount: searchVacancyParam.partyCount,
                membershipAuthID:searchVacancyParam.membershipAuthID,
                userFacility: searchVacancyParam.userFacility,
                kaiinKind:searchVacancyParam.kaiinKind,
                syoriKbn:"0"
            }
            setSearchVacancyParam(req);
            // カレンダー検索用検索情報取得
            common.doPost(vacancyOverviewApi, req, afterGetVacancy);
        }
        
    }

    const getCalendarStartDate = () => {
        return commonUtil.getDateFromString(searchVacancyParam.startDate, "-");
    }



    return (
        <div style={style.top}>
            <div style={isMobilePhone ? style.tabnaviMobile : style.tabnavi}>
                <Button buttonText={"カレンダーから探す"} onClick={() => setDisplaySwitch(true)} className={displaySwitch ? (isMobilePhone ? "golfTabStyle2Mobile" : "golfTabStyle2") : (isMobilePhone ? "golfTabStyleMobile" : "golfTabStyle")} />
                <Button buttonText={"条件を指定して探す"} onClick={() => setDisplaySwitch(false)} className={displaySwitch ? (isMobilePhone ? "golfTabStyleMobile" : "golfTabStyle") : (isMobilePhone ? "golfTabStyle2Mobile" : "golfTabStyle2")} />
            </div>
            <div style={isMobilePhone ? style.breadCrumb2 : style.breadCrumb}>
                <div style={style.linkArea}>
                    <Link to={"/reserve/top"} style={style.link} >HOME</Link>
                    <Label label=">" style={style.breadCrumbArrow} />
                    <Label label="ゴルフ予約" style={style.link} />
                </div>
            </div>
            <div style={isMobilePhone ? style.wrapperMobile : style.wrapper}>
                <div className="searchWrapper">
                    {displaySwitch ?
                        <div id="callender" style={displaySwitch ? { display: "block" } : { display: "none" }}>
                            <div style={isMobilePhone ? style.searchboxMobile : style.searchbox}>
                                <VacancyInfoContainer
                                    onClickPlay={onClickOpenSelectDateWindow}
                                    onClickOpenStartTimeWindow={onClickOpenStartTimeWindow}
                                    displaySwitch={displaySwitch}
                                    setVacancyInfo={setVacancyInfo}
                                    setVacancyWeek={setVacancyWeek}
                                    setMonthHead={setMonthHead}
                                    setMonthLast={setMonthLast}
                                    onClickOpenSelectAreaWindow={onClickOpenSelectAreaWindow}
                                    runGetVacancyList={runGetVacancyList}
                                    getWeekList={getWeekList}
                                    getYearMonth={getYearMonth} />
                            </div>
                            <div style={isMobilePhone ? style.searchboxMobile2 : style.searchbox}>
                                <VacancyInfoContainerCallender
                                    onClickPlay={onClickOpenSelectDateWindow}
                                    onClickOpenStartTimeWindow={onClickOpenStartTimeWindow}
                                    displaySwitch={displaySwitch}
                                    vacancyInfo={vacancyInfo}
                                    vacancyWeek={vacancyWeek}
                                    MonthHead={MonthHead}
                                    MonthLast={MonthLast}
                                    onClickMoveWeeks={onClickMoveWeeks}
                                    getCalendarStartDate={getCalendarStartDate}
                                    onClickOpenFacilityCalendarWindow={onClickOpenFacilityCalendarWindow} />
                            </div>
                        </div>
                        :
                        <div id="condition" style={displaySwitch ? { display: "none" } : { display: "block" }}>
                            <div style={isMobilePhone ? style.searchboxMobile : style.searchbox}>
                                <div style={NotDate ? { display: "block", color: "red", textAlign: "center", fontSize: "0.8rem", background: "rgba(255,255,255,0)", border: 0, fontWeight: "bold" } : { display: "none" }} > プレー日を選択してください</div>
                                <div style={NotStart ? { display: "block", color: "red", textAlign: "center", fontSize: "0.8rem", background: "rgba(255,255,255,0)", border: 0, fontWeight: "bold" } : { display: "none" }} > スタート時間を選択してください</div>
                                <div style={NotFacility ? { display: "block", color: "red", textAlign: "center", fontSize: "0.8rem", background: "rgba(255,255,255,0)", border: 0, fontWeight: "bold" } : { display: "none" }} > 施設を選択してください</div>
                                <div style={NotSearch ? { display: "block", color: "red", textAlign: "center", fontSize: "0.8rem", background: "rgba(255,255,255,0)", border: 0, fontWeight: "bold" } : { display: "none" }} > 一致するプランが０件です</div>
                                <div style={style.titleArea}>
                                    {isMobilePhone ? (<>
                                        <h5>条件を指定して探す</h5>
                                        <h6 style={style.keepLink} onClick={onClickOpenSavedSearchCriteriaWindow}>　&nbsp;保存した検索条件</h6>
                                    </>) : (<>
                                        <h3>条件を指定して探す</h3>
                                        <h4 style={style.keepLink} onClick={onClickOpenSavedSearchCriteriaWindow}>　&nbsp;保存した検索条件</h4>
                                    </>)}
                                </div>
                                <ConditionDesignationArea
                                    style={style}
                                    isMobilePhone={isMobilePhone}
                                    onClickOpenSelectDateWindow={onClickOpenSelectDateWindow}
                                    onClickOpenStartTimeWindow={onClickOpenStartTimeWindow}
                                    onClickOpenSelectAreaWindow={onClickOpenSelectAreaWindow}
                                    displaySwitch={displaySwitch}
                                    noDisplay={true} />

                            </div>
                            <div style={isMobilePhone ? style.searchboxMobile : style.searchbox}>
                                <Button buttonText="検 索" className={isMobilePhone ? "searchBtnStyleSp" : "searchBtnStylePc"} onClick={onClickSearch} course={getCourseCount()} />

                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

const style = {
    top: {
        //paddingBottom: "50px",
    },

    wrapper: {
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        textAlign: "center",
        width: "60%",
        margin: "50px auto",
        paddingBottom: "50px",
        fontSize: "80%",
    },
    wrapperMobile: {
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        textAlign: "center",
        width: "80%",
        margin: "auto",
        marginTop: "40px",
        padding: "5px 10px 0px",
        fontSize: "90%",
    },
    titleArea: {
        display: "flex",
        alignContent: "center",
        justifyContent: "space-between",
    },
    save: {
        margin: "0 0 0 auto",
    },
    saveMobile: {
        margin: "0 0 7px auto",
    },
    keepLink: {
        color: "#adadad",
        textDecoration: "underline",
        fontSize: "small",
        marginTop: "23px",
        cursor: "pointer",
        backgroundImage: `url(${img_save})`,
        backgroundPosition: 'left 0 bottom 1%',
        backgroundSize: '20%',
        backgroundRepeat: "no-repeat",
        padding: "0 0 0 5px",
        textDecorationThickness: "2px"
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
    },
    detailsButton: {
        color: "#4d4d4d",
        backgroundColor: "#d9d7d7",
        border: "none",
        padding: "10px 0",
        width: "100%",
        cursor: "pointer",
        position: "relative",
    },
    detailLabel: {
        display: "inline-block",
    },
    detailImage: {
        display: "inline-block",
        position: "absolute",
        right: "0",
        marginRight: "10px",
    },
    arwTop: {
        transform: "rotate(270deg)",
    },
    arwBtm: {
        transform: "rotate(90deg)",
    },
    tabnaviMobile: {
        backgroundColor: "#fff",
        width: "100%",
        height: "57px",
        justifyContent: "center",
        display: "flex",
        borderTop:"1px solid #eee",
        borderBottom:"1px solid #c0b283"
    },
    tabnavi: {
        backgroundColor: "#fff",
        width: "100%",
        height: "60px",
        justifyContent: "center",
        display: "flex",
        borderTop:"1px solid #eee",
        borderBottom:"1px solid #c0b283"
    },
    icon: {
        display: "block",
        position: "absolute",
        top: "10px",
        left: "40%",
        transform: "translate(0, 50%)"
    },
    breadCrumb: {
        display: "flex",
        justifyContent:"center",
    },
    linkArea:{
        paddingTop: "25px",
        color: "white",
        width: "60%",
        display:"flex"
    },
    breadCrumb2: {
        display: "none",
    },
    breadCrumbArrow: {
        marginRight: "5px",
        marginLeft: "5px",
        marginTop: "0px",
        color: "white",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    searchbox: {
        width: "80%",
        margin: "0px auto",
        paddingTop: "20px",
    },
    searchboxMobile: {
        margin: "0px auto",
    },
    searchboxMobile2: {
        width: "calc(100% + 20px)",
        margin: "0px 0px 0px -10px",
    },

    detailedConditionContainer: {
        width: "100%",
        border: "solid 1px #adadad",
        marginTop: "20px",
        fontSize: "small",
    },
    detailedConditionArea: {
        backgroundColor: "#fff",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-around",
        width: "100%",
    },
    courseCount: {
        margin: "30px 0 10px 0",
    },
    // CheckboxListBoxコンポーネントに引数として渡すスタイル情報
    divStyle: {
        display: "flex",
        flexWrap: "wrap",
        width: "80%",
        textAlign: "left",
        alignContent: "flex-start",
    },
    divStyleMobile: {
        display: "flex",
        flexWrap: "wrap",
        width: "90%",
        textAlign: "left",
        alignContent: "flex-start",
    },
    labelAreaStyle: {
        color: "#696969",
        width: "100%",
        borderBottom: "solid 1px #696969",
        marginTop: "30px",
        marginBottom: "15px",
    },
    // プレイスタイルの各チェックボックス要素の並び(2列)
    playStyleCheckArea: {
        width: "25%",
        paddingBottom: "15px",
    },
    // プレイスタイルの各チェックボックス要素の並び(2列)
    playStyleCheckAreaMobile: {
        width: "100%",
        paddingBottom: "15px",
    },
    monthStyle: {
        fontWeight: "bold",
        fontSize: "1.5rem",
        marginLeft: "5px",
    },
    monthStyleMobile: {
        fontWeight: "bold",
        fontSize: "1rem",
        marginLeft: "5px",
    },
};

const mapStateToProps = (state) => {
    return {
        playDate1: state.playDate1,
        group: state.group,
        course: state.course,
        detailCondition: state.detailCondition,
        startTime: state.startTime,
        login:state.login,
        kaiinken:state.kaiinken,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setDetailCondition: (item) => {
            dispatch({ type: "DETAIL_CONDITION", payload: { detailCondition: item } })
        },
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setStartTime: (item) => {
            dispatch({ type: "START_TIME", payload: { startTime: item } })
        },
        setGroup: (item) => {
            dispatch({ type: "GROUP", payload: { group: item } })
        },
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setKaiinken: (item) => {
            dispatch({ type: "KAIINKEN", payload: {kaiinken:item} })
        },
        setReserveCheckInfo: (item) => {
            dispatch({ type: "RESERVE_CHECK_INFO", payload: { reserveCheckInfo: item } })
        },
        setChangeReserveNo: (item) => {
            dispatch({ type: "CHANGE_RESERVE_NO", payload: { changeReserveNo: item } })
        },
        addTeeTimeList: (item) => {
            dispatch({ type: "ADD_TEETIME_LIST", payload: { teeTimeList: item } })
        },
        setPlayDate1: (item) => {
            dispatch({ type: "SELECT_PLAY_DATE1", payload: { playDate1: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(GolfSearchContainer);
